module.exports = __webpack_public_path__ + "img/app-imagen.e676ca47.png";